import {observable, action, computed} from 'mobx'
import {IConstituency} from '../types/constituency'

export class ConstituencyStore {
  @observable
  constituencies: IConstituency[] = []
  @action
  setConstituencies(constituencies: IConstituency[]) {
    this.constituencies = constituencies
  }

  @computed get getMunicipalityConstituencies() {
    return this.constituencies?.filter(c => c.election_type === 'municipality') || []
  }

  @computed get getCountyConstituencies() {
    return this.constituencies?.filter(c => c.election_type === 'county') || []
  }
}
